<!-- content begin -->
<div id="content" class="no-bottom no-top">
    <div id="top"></div>
  
    <!-- section begin -->
    <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/13.jpg)"
      data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
      <div class="overlay-bg t50">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <h1>Notification</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- section close -->
  
  <div id="section-services" style="padding-top: 20px;">
      <div class="container">
          <div class="row align-items-center">
              <div class="col-md-12">
                  <div class="row sequence">
                      <div class="col-md-12 sq-item wow sq-item wow animated" style="visibility: visible;">
                          <div class="feature-box style-2 left cus_ft_box">
                              <div class="text" style="text-align: left;">
                                  <span style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 0px 10px; color: #fff; border-radius: 5px; font-size: 16px; z-index: 1; top: 0px;">JC </span>
                                  <!--JVC/Con(IT)/Con(Tech) Recruitment-->
                                  JC Recruitment has been postponed. Further communication will be intimated shortly. 

                                </div>
                              </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row align-items-center">
              <div class="col-md-12">
                <div class="row sequence">
                  <div class="col-md-12 sq-item wow sq-item wow animated" style="visibility: visible;">
                    <div class="feature-box style-2 left cus_ft_box">
                      <div class="text" style="font-size: 18px; color: #000; text-align: left;">
                        <!-- <p>  Shortlisted Candidates List for Consultant IT <a href="assets/pdf/Consultant IT Shortlisted.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p> -->
                        <!-- <p>  Revised waiting, list candidates <a href="assets/pdf/JC waiting  list candidates.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p> -->
      
                        <!-- <p>The location of the vacancies indicated are tentative only. The final posting locations may vary from time to time subject to the requirement of the Organisation</p> -->
                      <!-- <p>Candidates attending the practical exam for JVC, Consultant IT & Technical support should bring all the relevant original certificates for verification.</p> <p>The practical exam  date for Consultant IT and Consultant Technical Support on 20th November 2021 </p> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row align-items-center">
            <div class="col-md-12">
                <div class="row sequence">
                    <div class="col-md-12 sq-item wow sq-item wow animated" style="visibility: visible;">
                        <div class="feature-box style-2 left cus_ft_box">
                            <div class="text" style="text-align: left;">
                                <!-- <span style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 0px 10px; color: #fff; border-radius: 5px; font-size: 16px; z-index: 1; top: 0px;">Con(IT) / Con(Tech) Recruitment </span> -->
                                <!--JVC/Con(IT)/Con(Tech) Recruitment-->
                              </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-12">
              <div class="row sequence">
                <div class="col-md-12 sq-item wow sq-item wow animated" style="visibility: visible;">
                  <div class="feature-box style-2 left cus_ft_box">
                    <div class="text" style="font-size: 18px; color: #000; text-align: left;">
                      <!-- <p>  Shortlisted Candidates List for Consultant IT <a href="assets/pdf/Consultant IT Shortlisted.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p> -->
                      <!-- <p> Selected Candidates List for Consultant IT <a href="assets/pdf/Consultant - IT Support - Final (07.01.2022).pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p>
                      <p> Selected Candidates List for Consultant Technical Support <a href="assets/pdf/Consultant - Technical Support (Final) - 07.01.2022 (1).pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p> -->
                      <!-- <p>The location of the vacancies indicated are tentative only. The final posting locations may vary from time to time subject to the requirement of the Organisation</p> -->
                    <!-- <p>Candidates attending the practical exam for JVC, Consultant IT & Technical support should bring all the relevant original certificates for verification.</p> <p>The practical exam  date for Consultant IT and Consultant Technical Support on 20th November 2021 </p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col-md-12">
            <div class="row sequence">
              <div class="col-md-12 sq-item wow sq-item wow animated" style="visibility: visible;">
                <div class="feature-box style-2 left cus_ft_box">
                  <div class="text" style="font-size: 18px; color: #000; text-align: left;">
                    <!-- <p>  Shortlisted Candidates List for Consultant IT <a href="assets/pdf/Consultant IT Shortlisted.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p> -->
                    <!-- <p> Due to administrative reasons, the further process of engagement of 78 Consultants(Technical and IT Consultant) of non-training profile at DGT Hqrs. and RDSDEs is cancelled <a href="assets/pdf/OM Tech and IT consultant cancellation.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p> -->
                    <!-- <p> Selected Candidates List for Consultant Technical Support <a href="assets/pdf/Consultant - Technical Support (Final) - 07.01.2022 (1).pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p> -->
                    <!-- <p>The location of the vacancies indicated are tentative only. The final posting locations may vary from time to time subject to the requirement of the Organisation</p> -->
                  <!-- <p>Candidates attending the practical exam for JVC, Consultant IT & Technical support should bring all the relevant original certificates for verification.</p> <p>The practical exam  date for Consultant IT and Consultant Technical Support on 20th November 2021 </p> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        

          <!-- <div class="row align-items-center">
            <div class="col-md-12">
                <div class="row sequence">
                    <div class="col-md-12 sq-item wow sq-item wow animated" style="visibility: visible;">
                        <div class="feature-box style-2 left cus_ft_box">
                            <div class="text" style="text-align: left;">
                                <span style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 0px 10px; color: #fff; border-radius: 5px; font-size: 16px; z-index: 1; top: 0px;"> JC Recruitment </span>
                              </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-12">
              <div class="row sequence">
                <div class="col-md-12 sq-item wow sq-item wow animated" style="visibility: visible;">
                  <div class="feature-box style-2 left cus_ft_box">
                    <div class="text" style="font-size: 18px; color: #000; text-align: left;">
                      <p>  Selected candidates and Waitlisted candidates. <a href="assets/pdf/JC Consolidated_-_Final.pdf" target="_blank" style="background: linear-gradient(to right, #eb3349, #f45c43); padding: 3px 10px; color: #fff; border-radius: 5px; font-size: 18px;">Click Here </a></p>
                      
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      </div>
  <!-- content close -->
  
  <style>
    .apy_before {
      background: black;
      font-size: 10px;
      line-height: 15px;
      padding: 5px 0px;
    }
  
    .appy_now_cls {
      background: linear-gradient(to right, #eb3349, #f45c43);
      color: #fff;
      padding: 0px 10px;
      border-radius: 10px;
      position: absolute;
      right: 20px;
    }
  
    .appy_now_cls.inactive {
      background: grey;
      border: 0px;
    }
  
    .appy_now_cls.inactive:hover {
      background: grey;
    }
  
    .appy_now_cls:hover {
      background: linear-gradient(to left, #eb3349, #f45c43);
      cursor: pointer;
    }
  
    .justify_cls {
      text-align: justify;
    }
  
    .justify_cls i {
      font-size: 15px;
    }
  
    .picframe.wow:hover,
    .picframe .overlay,
    .picframe .overlay:hover {
      background: rgba(0, 0, 0, 0.5);
    }
  
    a:hover {
      text-decoration: none;
      color: #fff;
    }
  </style>

<!-- <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">
        <div class="col-md-12 sq-item wow sq-item wow">
          <div class="feature-box style-2 left cus_ft_box">
            <div class="text" style="text-align: left;">
              <span
                style=" background: linear-gradient(to right, #eb3349, #f45c43); padding: 0px 10px; color: #fff; border-radius: 5px; font-size: 16px; z-index: 1; top: 0px;">
                Syllabus of JC Practical Exam </span>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

<div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">
        <div class="col-md-12 sq-item wow sq-item wow">

          <div class="feature-box style-2 left cus_ft_box">
            <div class="text" style="font-size: 18px; color: #000; text-align: left;">
              <p>

      
                1. Practical exam for JC is scheduled on 7th of September

              </p>
              <p>

                2. Practical exam will be conducted for the respective trades as per CITS standard
              </p>
              <p>
                3. The link for Hall Ticket will be provided shortly, please keep visiting the site for updates
              </p>
            </div>
          </div>



        </div>









      </div>
    </div>


  </div> -->